export const environment = {
  production: false,
  type: 'dev',
  region: 'europe',
  config: {
    ECL_PLATFORM_URL: 'https://ecl-platform.maersk-digital.dev',
    CIRE_SERVICE_URL: 'https://meccire-configurations-api-cdt.maersk.io',
    APP_NAME: 'mec-carrier-integration-ui-dev',
    RUM_API_KEY: '',
  },
};
